import { atom } from "jotai";

export const maintenanceStatusAtom = atom({
  enabled: false,
  manualLock: false,
  reason: "",
  message: "",
  updatedAt: null,
});

export const intendedPathAtom = atom(null);
